module.exports = __webpack_public_path__ + "Flag-642.f95d05d037cc37383722834b655b6f9f.svg";